/** Main-thread time per task while counting. */
const SLICE_MS = 16;
/** Longest wait for an idle period before the count starts anyway. */
const IDLE_START_TIMEOUT_MS = 5000;

/** Starts when idle, consumes the count in timed slices, and returns cleanup. */
export function scheduleInventoryCount<T>(
  startCounting: () => Generator<void, T, unknown>,
  onComplete: (inventory: T) => void
): () => void {
  let counting: Generator<void, T, unknown> | undefined;
  let cancelNext = () => {};
  const countSlice = () => {
    counting ??= startCounting();
    const sliceEnd = performance.now() + SLICE_MS;
    while (performance.now() < sliceEnd) {
      const step = counting.next();
      if (step.done) {
        onComplete(step.value);
        return;
      }
    }
    const handle = window.setTimeout(countSlice, 0);
    cancelNext = () => window.clearTimeout(handle);
  };

  if (typeof window.requestIdleCallback === 'function') {
    const handle = window.requestIdleCallback(countSlice, {
      timeout: IDLE_START_TIMEOUT_MS,
    });
    cancelNext = () => window.cancelIdleCallback(handle);
  } else {
    // Safari has no requestIdleCallback.
    const handle = window.setTimeout(countSlice, 0);
    cancelNext = () => window.clearTimeout(handle);
  }
  return () => cancelNext();
}
